import { rpcSpecification } from "./ep/endpoints";
import { survivorRpcSpec } from "./ep/endpointsSurvivor";
import { makeClientEndpoints } from "./types";

export const endpoints = makeClientEndpoints({
  ...rpcSpecification,
  ...survivorRpcSpec,
});
